import { useState } from "react";
import { Form } from "react-bootstrap";

const CheckboxOption = (props: any) => {

  let value = props.value ?? "";
  const UpdadeValue = (valueInput: any) => {
    props.handleChange(valueInput)
  }

  return (
    <>
      <Form.Check
        type={"radio"}
        inline
        value="Si"
        name="default-radio"
        id={`default-radio`}
        label={`Si`}
        checked={(value == "Si")}
        onChange={(e) => UpdadeValue(e.target.value)}
      />
      <Form.Check
        inline
        type={"radio"}
        value="No"
        name="default-radio"
        id={`default-radio`}
        label={`No`}
        checked={(value == "No")}
        onChange={(e) => UpdadeValue(e.target.value)}
      />
    </>
  )
}

export default CheckboxOption;